import React, { type JSX } from 'react';
import { ApolloError } from '@apollo/client';
import { Query } from '@apollo/client/react/components';

import {
  EkonomiskAnalysStandardColumnQuery as IEkonomiskAnalysStandardColumnQueryData,
  EkonomiskAnalysStandardColumnQueryVariables as IEkonomiskAnalysStandardColumnQueryVariables,
  EkonomiskAnalysStandardColumnQuery_ekanalysstandardcolumns,
} from './_QueryTypes/EkonomiskAnalysStandardColumnQuery';
import query from './EkonomiskAnalysStandardColumnQuery.gql';
import { KodplanConsumer } from '../../../../../../../../../../../../../Components/KodplanManager/Context/KodplanContext';

export type StandardColumnType =
  EkonomiskAnalysStandardColumnQuery_ekanalysstandardcolumns;

interface IStandardColumnQueryResult {
  standardColumns?: StandardColumnType[];
  loading: boolean;
  error?: ApolloError;
}

interface IProps {
  children: (result: IStandardColumnQueryResult) => JSX.Element;
}

const EkonomiskAnalysStandardColumnQuery: React.FunctionComponent<
  IProps
> = props => (
  <KodplanConsumer>
    {({ activeKodplan }) => (
      <Query<
        IEkonomiskAnalysStandardColumnQueryData,
        IEkonomiskAnalysStandardColumnQueryVariables
      >
        query={query}
        variables={{
          kodplanId: activeKodplan && activeKodplan.id ? activeKodplan.id : '',
        }}
        skip={activeKodplan == null}
      >
        {({ data, loading, error }) => {
          const standardColumns =
            data && data.ekanalysstandardcolumns
              ? (data.ekanalysstandardcolumns.filter(
                  x => x !== null
                ) as StandardColumnType[])
              : undefined;
          return props.children({ loading, error, standardColumns });
        }}
      </Query>
    )}
  </KodplanConsumer>
);

export default EkonomiskAnalysStandardColumnQuery;
